/**
 * `XXXX-XXXX-XXXX` of letters and digits. The portal only checks this shape.
 * The API rejects 0, O, 1, I, and L.
 */
const ACCESS_CODE_PATTERN = /^[A-Z0-9]{4}(?:-[A-Z0-9]{4}){2}$/;

/**
 * Upper-cases and trims the input. When it has exactly 12 characters once dashes are
 * removed, returns the dashed form `XXXX-XXXX-XXXX`; otherwise returns the trimmed,
 * upper-cased text unchanged so validation can report it. Used on every keystroke.
 *
 * @param raw what the student typed or pasted
 */
export function normalizeAccessCode(raw: string): string {
  const cleaned = (raw || "").trim().toUpperCase();
  const compact = cleaned.replace(/-/g, "");
  if (compact.length !== 12) {
    return cleaned;
  }
  return `${compact.slice(0, 4)}-${compact.slice(4, 8)}-${compact.slice(8, 12)}`;
}

/**
 * True when the code is `XXXX-XXXX-XXXX` of letters and digits. Does not reject
 * 0, O, 1, I, or L; the API does that.
 *
 * @param code raw or normalized code
 */
export function isValidAccessCodeFormat(code: string): boolean {
  return ACCESS_CODE_PATTERN.test(normalizeAccessCode(code));
}
